import { Box, Paper, Typography } from "@mui/material";
import { formatCurrency } from "../../../shared/utils";

interface VariationMetric {
    label: string;
    value: number;
    color?: string;
    description?: string;
}

const variationMetrics: VariationMetric[] = [
    {
        label: 'Total Variation Value',
        value: 720000,
        description: 'Combined approved and pending',
    },
    {
        label: 'Total Variation Value',
        value: 450000,
        color: 'success.main',
    },
    {
        label: 'Total Variation Value',
        value: 270000,
        color: 'warning.main',
    },
];

export const VariationsImpact = () => {
    return (
        <Paper variant="outlined" sx={{ m: 2, mb: 3 }}>
            <Typography variant="subtitle2" color="text.secondary" sx={{ px: 2, py: 2 }}>
                Change & Variations Impact
            </Typography>
            <Box 
                display="flex" 
                alignItems="center" 
                justifyContent="space-between" 
                px={2} 
                pb={2} 
                gap={1}
            >
                {variationMetrics.map((metric, index) => (
                    <Box 
                        key={index}
                        display="flex" 
                        flexDirection="column" 
                        alignItems="start" 
                        px={2} 
                        pb={2}
                    >
                        <Typography variant="caption" color="text.secondary">
                            {metric.label}
                        </Typography>
                        <Typography 
                            variant="subtitle1" 
                            color={metric.color || 'text.primary'}
                        >
                            {formatCurrency(metric.value)}
                        </Typography>
                        {metric.description && (
                            <Typography variant="caption" color="text.secondary">
                                {metric.description}
                            </Typography>
                        )}
                    </Box>
                ))}
            </Box>
        </Paper>
    );
};
